import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="coprep-footer-section">
      <div className="coprep-footer-container">
        
        {/* Main Footer Links Columns */}
        <div className="footer-links-grid">
          
          {/* Brand Col */}
          <div className="footer-brand-col">
            <div className="footer-logo-row" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
              <div className="footer-bolt-badge">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                </svg>
              </div>
              <span className="footer-brand-title">CrackIT <span className="title-accent-tag">AI</span></span>
            </div>
            <p className="footer-brand-description">
              Real-time interview copilot helping engineers crack technical and behavioral rounds with confidence.
            </p>
            <div className="footer-social-chips">
              <span className="social-chip">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ marginRight: '4px' }}>
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                256-Bit SSL
              </span>
              <span className="social-chip">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ marginRight: '4px' }}>
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                </svg>
                &lt;180ms Latency
              </span>
            </div>
          </div>

          {/* Product Col */}
          <div className="footer-nav-col">
            <h5 className="footer-col-heading">Copilot</h5>
            <ul className="footer-links-list">
              <li><a href="#features">Live Copilot</a></li>
              <li><a href="#features">Stealth Overlay</a></li>
              <li><a href="#features">Screen OCR</a></li>
              <li><a href="#platforms">Supported Platforms</a></li>
              <li><a href="#how-it-works">How It Works</a></li>
            </ul>
          </div>

          {/* Career & Resume Col */}
          <div className="footer-nav-col">
            <h5 className="footer-col-heading">Features</h5>
            <ul className="footer-links-list">
              <li><a href="#pricing">Pricing &amp; Credits</a></li>
              <li><a href="#features">Resume Analyzer</a></li>
              <li><a href="#features">Mock Interviews</a></li>
              <li><a href="#features">Resume Builder</a></li>
              <li><a href="#features">Auto-Apply</a></li>
            </ul>
          </div>

          {/* Company & Support Col */}
          <div className="footer-nav-col">
            <h5 className="footer-col-heading">Support</h5>
            <ul className="footer-links-list">
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#download">Download App</a></li>
              <li><a href="mailto:support@crackit.si">Contact Us</a></li>
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/refund-policy" style={{ color: '#f87171' }}>Refund Policy</Link></li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar">
          <div className="footer-bottom-left">
            <p className="footer-copy-text">
              © {new Date().getFullYear()} CrackIT AI Technologies Inc. All rights reserved.
            </p>
            <div className="footer-legal-links-row">
              <Link to="/terms" className="footer-sub-link">Terms</Link>
              <span className="dot-sep">•</span>
              <Link to="/privacy" className="footer-sub-link">Privacy</Link>
              <span className="dot-sep">•</span>
              <Link to="/refund-policy" className="footer-sub-link">Refund Policy</Link>
            </div>
          </div>
          <div className="footer-status-pill">
            <span className="status-ping"></span>
            <span>All Systems Operational</span>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
